import { collectionEngineV1 } from '../apis.js';
export { AICreditFeature } from '@debbie/common/dist/ai/index.js';
const req = collectionEngineV1('/ai');
const autoReplyReq = collectionEngineV1('/ai/auto-reply');
export const genSuggestion = (data) => req('POST', `/message-suggestion`, {
    body: data,
});
// Auto-reply API functions
export const triggerAutoReply = (interactionId) => autoReplyReq('POST', `/generate`, {
    body: { interactionId },
});
export const getAutoReply = (id) => autoReplyReq('GET', `/${id}`);
export const getAutoRepliesByInteraction = (interactionId) => autoReplyReq('GET', `/interaction/${interactionId}`);
export const getAutoRepliesByCase = (caseId) => autoReplyReq('GET', `/case/${caseId}`);
export const getUsage = () => req('GET', `/usage`);
export const runCategoryDiscovery = () => req('POST', `/category-discovery/run`, {
    body: {},
});
export const getProposedCategories = () => req('GET', `/category-discovery/proposals`);
export const rerunCategoryDiscoveryAggregation = (runId) => req('POST', `/category-discovery/runs/${runId}/aggregate`, { body: {} });
export const acceptProposedCategory = (id) => req('POST', `/category-discovery/proposals/${id}/accept`, { body: {} });
export const rejectProposedCategory = (id) => req('POST', `/category-discovery/proposals/${id}/reject`, { body: {} });
//# sourceMappingURL=ai.js.map